import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { Quote, Target, Lightbulb, Shield } from 'lucide-react';
import './Vision.css';

const Vision = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const values = [
    {
      icon: <Target size={32} />,
      title: 'Interoperability',
      description: 'Breaking down barriers between blockchain networks to create a truly unified financial infrastructure without compromise.',
    },
    {
      icon: <Lightbulb size={32} />,
      title: 'Innovation',
      description: 'Pioneering multi-L1 settlement technology with dual-runtime execution and sovereign consensus mechanisms.',
    },
    {
      icon: <Shield size={32} />,
      title: 'Security First',
      description: 'Financial-grade reliability with comprehensive audits, MEV resistance, and institutional-level security standards.',
    },
  ];

  return (
    <section id="vision" className="vision-alien" data-testid="vision-section" ref={ref}>
      <div className="section-container">
        <motion.div
          className="section-header-alien"
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
        >
          <div className="section-tag">
            <div className="tag-line"></div>
            <span className="tag-text">OUR MISSION</span>
            <div className="tag-line"></div>
          </div>
          <h2 className="section-title-alien">
            <span className="title-normal">VISION &</span>
            <span className="title-highlight">VALUES</span>
          </h2>
        </motion.div>

        <motion.div
          className="vision-quote-container"
          initial={{ opacity: 0, scale: 0.95 }}
          animate={inView ? { opacity: 1, scale: 1 } : {}}
          transition={{ duration: 0.8 }}
        >
          <Quote className="quote-icon" size={48} />
          <blockquote className="vision-quote">
            The future of finance demands interoperability without compromise. Nomoex Chain is that
            bridge — not a connector of tokens, but a connector of ecosystems. A chain built to move
            capital, data, and trust seamlessly across networks.
          </blockquote>
          <div className="quote-attribution">
            <div className="attribution-line"></div>
            <span>NOMOEX VISION STATEMENT</span>
            <div className="attribution-line"></div>
          </div>
        </motion.div>

        <div className="values-grid">
          {values.map((value, index) => (
            <motion.div
              key={index}
              className="value-card-alien"
              initial={{ opacity: 0, y: 30 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.5, delay: 0.3 + index * 0.1 }}
              whileHover={{ y: -8, scale: 1.02 }}
            >
              <div className="value-icon-alien">{value.icon}</div>
              <h3 className="value-title-alien">{value.title}</h3>
              <p className="value-description-alien">{value.description}</p>
            </motion.div>
          ))}
        </div>

        <motion.div
          className="labs-section-alien"
          initial={{ opacity: 0 }}
          animate={inView ? { opacity: 1 } : {}}
          transition={{ delay: 0.6 }}
        >
          <h3 className="labs-title">Powered by <span className="text-highlight">Nomoex Labs</span></h3>
          <p className="labs-description">
            Nomoex Labs accelerates ecosystem growth through strategic funding, technical support, and co-marketing initiatives. 
            We empower developers to build innovative dApps with grants up to $50K per project and achieve $1M+ TVL milestones.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default Vision;